import { render, staticRenderFns } from "./VideoStorageConfigPage.vue?vue&type=template&id=00620751&scoped=true&"
import script from "./VideoStorageConfigPage.vue?vue&type=script&lang=js&"
export * from "./VideoStorageConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoStorageConfigPage.vue?vue&type=style&index=0&id=00620751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00620751",
  null
  
)

export default component.exports